import Box from '@mui/material/Box';

import { useBoolean, useOnboardingStore } from '@zeta-core';
import NavVertical from './nav-vertical';
import { NAV } from '../config-layout';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export function RegisterClientLayout({ children }: Props) {
  const nav = useBoolean();
  const { hideSidebar } = useOnboardingStore((state) => state);
  const renderNavVertical = <NavVertical openNav={nav.value} />;

  return (
    <Box
      sx={{
        minHeight: 1,
        display: 'flex',
        flexDirection: { xs: 'column', lg: 'row' },
      }}
    >
      {hideSidebar ? (
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            minHeight: 1,
            display: 'flex',
            flexDirection: 'column',
            width: '100vw',
            height: '100vh',
          }}
        >
          {children}
        </Box>
      ) : (
        <>
          {renderNavVertical}
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              minHeight: 1,
              display: 'flex',
              flexDirection: 'column',
              width: `calc(100vw - ${NAV.W_VERTICAL_ONBOARDING})`,
            }}
          >
            {children}
          </Box>
        </>
      )}
    </Box>
  );
}
